import { formatDateTime } from "@/common/utils/formatters";
import { ArrowBigRightIcon, Building2Icon } from "lucide-react";
import { Link } from "react-router-dom";
import { NegotiationData } from "../types/negotiations.type";
import { negotiationStatus } from "../constants/negotiationStatus.constant";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { getDateDiffInDays } from "@/common/utils/date";

export class NegotiationsTransformer {
  static tableTransformer() {
    return (negotiations: NegotiationData[]) => {
      return negotiations.map((negotiation) => {
        return {
          ...negotiation,
          _className: negotiation.status === 'awaiting_client_response' && 'bg-yellow-op-2',
          status: negotiation.status ? negotiationStatus[negotiation.status] : '',
          created_at: negotiation.created_at ? formatDateTime(new Date(negotiation.created_at)) : '',
          accepted_at: negotiation.accepted_at ? formatDateTime(new Date(negotiation.accepted_at)) : '',
          due_for: negotiation.due_at ? `${getDateDiffInDays(new Date(), new Date(negotiation.due_at))} dias` : '',
          establishment_company: (
            <ImageWithDisplayName
              placeholderIcon={Building2Icon}
              imageUrl={negotiation.establishment_company?.general_information?.company_logo?.url}
              displayName={negotiation.establishment_company?.general_information?.fantasy_name}
            />
          ),
          actions: (
            <Link to={`/negotiations/${negotiation.id}`}>
              <ArrowBigRightIcon />
            </Link>
          ),
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (negotiations: NegotiationData[]) => {
      return negotiations.map((negotiation) => ({
        route: `/negotiations/${negotiation.id}`,
        items: [
          ['Código', negotiation.number],
          ['Status', negotiation.status ? negotiationStatus[negotiation.status] : ''],
          ['Estabelecimento', negotiation.establishment_company?.general_information?.fantasy_name || ''],
        ],
      }));
    };
  }
}
